import React from 'react';
import LoginIcon from '@mui/icons-material/Login';
import PersonIcon from '@mui/icons-material/Person';
import { Box, Avatar, Button } from '@mui/material';
import { LanguageSelector } from '../common';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../hooks/useAuth';

const DesktopUserSection = ({ 
  isLoggedIn,
  userPhoto,
  onProfileClick,
  onLoginClick,
  hideLoginButton = false,
  isAnalyzePage,
  t
}) => {
  return (
    <Box sx={{ 
      display: 'flex', 
      alignItems: 'center', 
      gap: 2, 
      flexShrink: 0 
    }}>
      <LanguageSelector onAnalyzePage={isAnalyzePage} />
      
      {isLoggedIn ? (
        <Avatar
          src={userPhoto}
          onClick={onProfileClick}
          sx={{
            width: 32,
            height: 32,
            cursor: 'pointer',
            '&:hover': {
              opacity: 0.8
            }
          }}
        >
          {!userPhoto && <PersonIcon />}
        </Avatar>
      ) : (
        !hideLoginButton && (
          <Button
            variant="outlined"
            onClick={onLoginClick}
            startIcon={<LoginIcon />}
            sx={{
              borderColor: '#1976d2',
              color: '#1976d2',
              '&:hover': {
                borderColor: '#1565c0',
                bgcolor: 'rgba(25, 118, 210, 0.04)'
              }
            }}
          >
            {t('common.login')}
          </Button>
        )
      )}
    </Box>
  );
};

export default DesktopUserSection; 